/* eslint-disable */
import BaseService from "../../../BaseService";

const { http } = BaseService();

// API
export function CapThongKeGetAll(postdata) {
  const data = { ...postdata };
  return http({
    url: "CapThongKe/getAll",
    method: "get",
    data,
  });
}

export function CapThongKeCreate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "CapThongKe/create",
    method: "post",
    data,
  });
}

export function CapThongKeUpdate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "CapThongKe/update",
    method: "post",
    data,
  });
}

export function CapThongKeDelete(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "CapThongKe/delete",
    method: "post",
    data,
  });
}

export function CapThongKeGetById(postdata) {
  return http({
    url: "CapThongKe/get-by-id/" + postdata,
    method: "get",
  });
}
export function CapThongKeGetByCode(postdata) {
  return http({
    url: "CapThongKe/get-by-code/" + postdata,
    method: "get",
  });
}

export function DonViThongKeGetByCode(postdata) {
  return http({
    url: "DonViThongKe/get-by-code/" + postdata,
    method: "get",
  });
}

export function DonViThongKeCreate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "DonViThongKe/create",
    method: "post",
    data,
  });
}
export function DonViThongKeDelete(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "DonViThongKe/delete",
    method: "post",
    data,
  });
}
